<template>
  <div class="app-textarea">
    <div v-if="label" class="field-label">
      <v-icon v-if="labelIcon" size="18">{{ labelIcon }}</v-icon>
      <span>{{ label }}</span>
    </div>
    <v-textarea v-model="model" :class="fieldClass" 
    auto-grow
    :variant="variant" :flat="flat" :hide-details="hideDetails"
      v-bind="fieldAttrs" />
  </div>
</template>

<script setup lang="ts">
import { computed, useAttrs } from "vue";

defineOptions({
  inheritAttrs: false,
});

const model = defineModel();

const props = withDefaults(
  defineProps<{
    variant?: "solo" | "filled" | "outlined" | "plain" | "solo-filled" | "solo-inverted" | "underlined";
    flat?: boolean;
    hideDetails?: boolean | "auto";
    label?: string;
    labelIcon?: string;
  }>(),
  {
    variant: "solo",
    flat: true,
    hideDetails: "auto",
    label: "",
    labelIcon: "",
  },
);

const attrs = useAttrs();
const fieldClass = computed(() => ["app-textarea__input", attrs.class]);

const fieldAttrs = computed(() => {
  const { class: _class, ...rest } = attrs;
  return rest;
});
</script>

<style scoped>
.app-textarea {
  width: 100%;
}

.field-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--color-subtitle);
  font-weight: 500;
  font-size: 13px;
  margin-bottom: 6px;
  padding: 0 10px;
}


.app-textarea__input :deep(.v-field__input) {
  padding: 10px 16px;
  font-size: 0.85rem;
}
</style>
